export const statusLabels: Record<string, string> = {
  PLANNED: "计划中",
  ACTIVE: "推进中",
  PAUSED: "已暂停",
  COMPLETED: "已完成",
  CANCELLED: "已取消",
  ARCHIVED: "已归档",
  TODO: "待办",
  IN_PROGRESS: "进行中",
  WAITING_EXTERNAL: "等待外部",
  BLOCKED: "受阻",
  DRAFT: "草稿",
  PUBLISHED: "已发布",
  NONE: "正常",
  WATCH: "需关注",
  AT_RISK: "有风险"
};

export const eventLabels: Record<string, string> = {
  ACTION: "行动",
  PROGRESS: "进展",
  RESULT: "结果",
  OUTCOME: "成果",
  DECISION: "决策",
  ISSUE: "问题",
  FEEDBACK: "反馈",
  LEARNING: "学习",
  APPLICATION: "应用",
  REVIEW: "复盘",
  MILESTONE: "里程碑",
  STATUS: "状态"
};

export function formatDate(value: string | null | undefined, options?: Intl.DateTimeFormatOptions) {
  if (!value) return "未设置";
  return new Intl.DateTimeFormat("zh-CN", {
    month: "short",
    day: "numeric",
    ...options
  }).format(new Date(value));
}

export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat("zh-CN", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(value));
}

export function formatMoney(amountMinor: number, currency: string) {
  return new Intl.NumberFormat("zh-CN", {
    style: "currency",
    currency,
    minimumFractionDigits: 2
  }).format(amountMinor / 100);
}

export function relativeDue(value: string | null) {
  if (!value) return null;
  const today = new Date();
  const target = new Date(`${value}T00:00:00`);
  const days = Math.round(
    (target.getTime() -
      new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime()) /
      86_400_000
  );
  if (days < 0) return `逾期 ${Math.abs(days)} 天`;
  if (days === 0) return "今天到期";
  if (days === 1) return "明天到期";
  return `${days} 天后`;
}

